import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Icon from '../../../../components/Icons';
import Accordion from '../../../../components/Accordion';
import CardDefault from '../../../../components/Cards/Default';
import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';
import Modal from '../../../../components/Modal';
import Loading from '../../../../components/Loading';
import PageLoader from '../../../../components/PageLoader';

import { LinkCardCustom } from '../../../../components/Cards/LinkCard';

import { useGlobal } from '../../../../contexts/Global/context';

import { buscarCentroCusto, excluirCentroCusto } from '../../../../services';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import { checkIsSupport } from '../../../../utils';

function CentroDeCusto({ location: { cameFromForm, message } }) {
    const { dataActiveContract, setShowSupportModal } = useGlobal();

    const [showModal, setShowModal] = useState(false);
    const [costCentersList, setCostCentersList] = useState([]);
    const [dataDeletingCostCenter, setDataDeletingCostCenter] = useState({});
    const [costCenterDeleted, setCostCenterDeleted] = useState(false);
    const [dataAlertMessage, setDataAlertMessage] = useState({
        title: message,
    });
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);

    const history = useHistory();

    const LINK_FORM = './formulario_centro_custo';

    async function loadCostCentersList(contract) {
        const response = (await buscarCentroCusto(contract)) || [];

        setCostCentersList(response);

        setAlreadySearched(true);
    }

    useEffect(() => {
        loadCostCentersList(dataActiveContract.numero);
    }, []);

    function handleEditCostCenter(dataCostCenter) {
        history.push({
            pathname: LINK_FORM,
            dataCostCenter,
        });
    }

    async function handleDeleteCostCenter(dataCostCenter) {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingDelete(true);

        const response = await excluirCentroCusto(dataCostCenter.codigoTsCentroCusto);

        const deleteSuccessMessage = {
            title: 'Você excluiu um centro de custo.',
        };

        setCostCenterDeleted(true);

        setShowModal(false);

        if (response.sucesso) {
            loadCostCentersList(dataActiveContract.numero);

            setDataAlertMessage(deleteSuccessMessage);

            setLoadingDelete(false);

            return;
        }

        setDataAlertMessage({
            type: 1,
            title: 'Ocorreu um erro ao excluir o centro de custo.',
        });

        setLoadingDelete(false);
    }

    function createActionsIcons(costCenter) {
        return (
            <>
                <S.ContainerIcon
                    style={{ marginRight: 25 }}
                    onClick={async () => {
                        setPageLoading(true);

                        const [fullDataCostCenter] = (await buscarCentroCusto(
                            dataActiveContract.numero,
                            costCenter.codigoCentroCusto
                        )) || [{}];

                        handleEditCostCenter(fullDataCostCenter);
                    }}
                >
                    <Icon name="edit" title="Alterar" />
                </S.ContainerIcon>
                <S.ContainerIcon
                    onClick={() => {
                        setShowModal(true);

                        setDataDeletingCostCenter(costCenter);
                    }}
                >
                    <Icon name="delete" title="Excluir" />
                </S.ContainerIcon>
            </>
        );
    }

    function EmptyList() {
        return alreadySearched ? (
            <LinkCardCustom
                link={LINK_FORM}
                title="Novo centro de custo"
                desc="Adicione e gerencie o centro de custo de sua empresa."
                icons={{ left: { name: 'work_outline' } }}
            />
        ) : (
            <S.ContainerLoading>
                <Loading loading />
            </S.ContainerLoading>
        );
    }

    return (
        <PageContainer>
            {costCentersList.length === 0 ? (
                <EmptyList />
            ) : (
                <>
                    {(cameFromForm || costCenterDeleted) && <Alert type={3} {...dataAlertMessage} />}

                    <Accordion title="Centro de custo">
                        {costCentersList.map((costCenter) => {
                            const ActionsIcons = createActionsIcons(costCenter);

                            const title = `${costCenter.codigoCentroCusto} - ${costCenter.nomeCentroCusto}`;

                            return (
                                <CardDefault
                                    key={costCenter.codigoCentroCusto}
                                    title={title}
                                    actionsIcons={ActionsIcons}
                                />
                            );
                        })}
                    </Accordion>

                    <ContainerButton style={{ marginTop: '20px' }}>
                        <Button id="continueStep" type="primary" onClick={() => history.push(LINK_FORM)}>
                            Novo centro de custo
                        </Button>
                    </ContainerButton>
                </>
            )}

            <Modal
                title="Você quer excluir o centro de custo?"
                subtitle="O centro de custo será definitivamente excluído da plataforma."
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button
                    type="secondary"
                    onClick={() => {
                        setShowModal(false);
                        setDataDeletingCostCenter({});
                    }}
                >
                    Não quero
                </Button>

                <Button
                    type="primary"
                    loading={loadingDelete}
                    disabled={loadingDelete}
                    onClick={() => handleDeleteCostCenter(dataDeletingCostCenter)}
                >
                    Sim, quero
                </Button>
            </Modal>

            <PageLoader loading={pageLoading} />
        </PageContainer>
    );
}

export default CentroDeCusto;
